export default __webpack_public_path__ + "static/media/icon_tick.8160348c.svg";